<div id="fab-dismiss" *ngIf="isOpen" (click)="toggle()"></div>

<div class="fab-container">
  <button mat-mini-fab color="primary" class="fab-toggler" (click)="toggle()">
    <span [ngClass]="getIconClass(currentLanguage)"></span>
  </button>

  <div [@speedDialStagger]="languages.length">
    <button *ngFor="let language of languages" mat-mini-fab class="fab-secondary" color="secondary"
      (click)="onChangeLanguage(language)">
      <span [ngClass]="getIconClass(language)"></span>
    </button>
  </div>
</div>